import React, { Component } from 'react';
import './App.css';
// import BubblesortDemo from './BubblesortDemo';
// import QuickSortDemo from './QuickSortDemo';
import Demo from './Demo';
import BubbleSortAlgorithm from './algorithms/bubblesort';
import QuicksortAlgorithm from './algorithms/quicksort';
import MergesortAlgorithm from './algorithms/mergesort';
import HeapsortAlgorithm from './algorithms/heapsort';
import InsertionAlgorithm from './algorithms/insertionsort';
import AnimationDelay from './utils/AnimationDelay'
import CocktailSortAlgorithm from './algorithms/cocktailshakersort'
import RadixSortAlgorithm from './algorithms/radixsort';

class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      algorithms: [

        {
          title: 'cocktailshaker',
          algorithm: new CocktailSortAlgorithm({
            delayController: new AnimationDelay({stepsPerFrame: 1})
          }),
        },
        {
          title: 'insertionsort',
          algorithm: new InsertionAlgorithm({
            delayController: new AnimationDelay({stepsPerFrame: 1})
          }),
        },
        {
          title: 'bubblesort',
          algorithm: new BubbleSortAlgorithm({
            delayController: new AnimationDelay({stepsPerFrame: 1}),
          }),
        },
        {
          title: 'quicksort',
          algorithm: new QuicksortAlgorithm({
            delayController: new AnimationDelay({stepsPerFrame: 1}),
          }),
        },
        {
          title: 'mergesort',
          algorithm: new MergesortAlgorithm({
            delayController: new AnimationDelay({stepsPerFrame: 1}),
          }),
        },
        {
          title: 'heapsort',
          algorithm: new HeapsortAlgorithm({
            delayController: new AnimationDelay({stepsPerFrame: 1})
          })
        },
        {
          title: 'radixsort',
          algorithm: new RadixSortAlgorithm({
            delayController: new AnimationDelay({stepsPerFrame: 1})
          })
        },
      ],
    }
  }
  render() {
    return (
      <div className="App">
        <div>
          {
            this.state.algorithms.map((algorithm) => {
              return (
                <div key={algorithm.title}>
                  <Demo
                    width={algorithm.width || 50}
                    height={algorithm.height || 20}
                    sortAlgorithm={algorithm}
                  />
                </div>
              )
            })
          }
        </div>
        {/* <div>
          <BubblesortDemo
            width={360}
            height={20}
          />
        </div>
        <div>
          <QuickSortDemo
            width={360}
            height={20}
          />
        </div> */}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js